export default function Fleet() {
  const vehicles = [
    {
      name: 'Basic Sedan',
      image: 'https://public.readdy.ai/ai/img_res/aa3e996550ab3affff82c73f5ad6a138.jpg',
      features: ['40+ MPG', 'Low Insurance', 'Easy Maintenance'],
      seats: '5 Seats',
      transmission: 'Automatic'
    },
    {
      name: 'Budget Hatchback',
      image: 'https://readdy.ai/api/search-image?query=small-budget-friendly-gray-hatchback-economy-car-three-quarter-front-view-on-clean-white-studio-background-professional-automotive-photography-showcasing-ultra-compact-affordable-design-ideal-for-food-delivery-and-rideshare-gig-work&width=800&height=600&seq=fleet-eco-002&orientation=landscape',
      features: ['Best Fuel Economy', 'Affordable Parts', 'City Friendly'],
      seats: '4 Seats',
      transmission: 'Automatic'
    },
    {
      name: 'Economy Sedan',
      image: 'https://readdy.ai/api/search-image?query=simple-silver-economy-sedan-budget-car-side-profile-on-clean-white-studio-background-professional-automotive-photography-emphasizing-cost-effective-reliable-transportation-perfect-for-gig-economy-workers-and-daily-commuters&width=800&height=600&seq=fleet-eco-003&orientation=landscape',
      features: ['Proven Reliability', 'Low Running Costs', 'Great Value'],
      seats: '5 Seats',
      transmission: 'Automatic'
    },
    {
      name: 'Compact Car',
      image: 'https://readdy.ai/api/search-image?query=basic-blue-compact-economy-car-three-quarter-view-on-clean-white-studio-background-professional-automotive-photography-showing-affordable-practical-design-ideal-for-budget-conscious-delivery-drivers-and-transportation-workers&width=800&height=600&seq=fleet-eco-004&orientation=landscape',
      features: ['Lowest Weekly Rate', 'Easy to Drive', 'Minimal Upkeep'],
      seats: '5 Seats',
      transmission: 'Automatic'
    }
  ];

  return (
    <section id="fleet" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Economy Fleet
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Budget-friendly, fuel-efficient vehicles perfect for maximizing your earnings as a gig worker
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-product-shop>
          {vehicles.map((vehicle, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-full h-56 overflow-hidden">
                <img
                  src={vehicle.image}
                  alt={vehicle.name}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{vehicle.name}</h3>
                <div className="flex items-center gap-4 mb-4 text-sm text-gray-600">
                  <div className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    <span>{vehicle.seats}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <i className="ri-settings-3-line"></i>
                    <span>{vehicle.transmission}</span>
                  </div>
                </div>
                <div className="space-y-2">
                  {vehicle.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-teal-600"></i>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}